import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ value, onChange, placeholder, testId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} value={value} onChange={onChange} placeholder={placeholder} className="w-full p-4 pr-12 rounded-2xl border bg-white" data-testid={testId} />
      <button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400">{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
    </div>
  );
};
